import { render } from "./rightConcent.vue?vue&type=template&id=88ba80ba&scoped=true&lang=true"
import script from "./rightConcent.vue?vue&type=script&lang=js"
export * from "./rightConcent.vue?vue&type=script&lang=js"

import "./rightConcent.vue?vue&type=style&index=0&id=88ba80ba&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/FK-YF23001-01-生产-01-综合管理后台sznc_admin-前端构建部署/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88ba80ba"]])

export default __exports__